import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { LocalizationKeys } from '../../i18n';
import { Severity } from './helpers';

type Props = {
  messageKey: LocalizationKeys;
  severity: Severity;
};

const bannerBackground: Record<Severity, string> = {
  low: 'action.disabledBackground',
  medium: 'warning.main',
} as const;

const bannerColor: Record<Severity, string> = {
  low: 'warning.light',
  medium: 'warning.contrastText',
};

const WarningIcon = (
  <SvgIcon fontSize="large">
    <IconAlertTriangle />
  </SvgIcon>
);

const bannerIcon: Record<Severity, ReactNode> = {
  low: WarningIcon,
  medium: WarningIcon,
};

const getUIConfig = (severity: Severity) => {
  return {
    backgroundColor: bannerBackground[severity],
    color: bannerColor[severity],
    icon: bannerIcon[severity],
  };
};

const OverduePaymentsBanner = ({ severity, messageKey }: Props) => {
  const intl = useIntl();
  const { icon, backgroundColor, color } = getUIConfig(severity);

  return (
    <Stack
      sx={{ backgroundColor, minHeight: 40 }}
      justifyContent="center"
      alignItems="center"
    >
      <Typography color={color} component="div" variant="body2">
        <Stack direction="row" spacing={1} sx={{ svg: { fontSize: '1.5em' } }}>
          {icon}
          <span>{intl.formatMessage({ id: messageKey })}</span>
        </Stack>
      </Typography>
    </Stack>
  );
};

export { OverduePaymentsBanner };
